import { logUsage } from 'owa-analytics';
import getCurrentZoomScale from 'owa-custom-zoom-store/lib/utils/getCurrentZoomScale';

export default function logEmbiggenZoomSettingDatapoint(): void {
    /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
     * BASELINE: DO NOT COPY/PASTE!
     *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
    logUsage('EmbiggenZoomSetting', undefined, { zoomScale: getCurrentZoomScale() });
}
